import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const UPLOAD_CSV_CUSTOM_WATCHLIST = createAsyncActionType('UPLOAD_CSV_CUSTOM_WATCHLIST');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/types/uploadCsvCustomWatchlistTypes.js